module.exports = __webpack_public_path__ + "static/media/privacy-2023-4.0044cd01.webp";